import { withBasePath } from "@/lib/portal/base-path";

/** Static brand assets under `public/abc-fitness/brand/`. */
export const ABC_FITNESS_BRAND_LOGO = "/abc-fitness/brand/logo.png";

export function getAbcFitnessBrandLogoHref(): string {
  return withBasePath(ABC_FITNESS_BRAND_LOGO);
}
